/* NAWA theme script: motion, drawers, search, cart (Shopify Ajax API), product options. */
(function () {
  'use strict';
  var C = window.NAWA || {};
  var R = C.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function money(cents) {
    var f = C.moneyFormat || '${{amount}}', v = (cents || 0) / 100, m = f.match(/\{\{\s*(\w+)\s*\}\}/), k = m ? m[1] : 'amount';
    function fmt(n, d, ts, ds) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
    var s = k === 'amount_no_decimals' ? fmt(v, 0, ',', '.') : k === 'amount_with_comma_separator' ? fmt(v, 2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? fmt(v, 0, '.', ',') : k === 'amount_with_apostrophe_separator' ? fmt(v, 2, "'", '.') : fmt(v, 2, ',', '.');
    return f.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  var waUrl = function (msg) { return 'https://wa.me/' + C.whatsapp + '?text=' + encodeURIComponent(msg); };
  function toast(t) { $$('.toast').forEach(function (x) { x.remove(); }); var d = document.createElement('div'); d.className = 'toast'; d.setAttribute('role', 'status'); d.textContent = t; document.body.appendChild(d); setTimeout(function () { d.remove(); }, 3200); }

  /* ---------- Reveal on scroll (content already on screen shows at once) ---------- */
  var io = 'IntersectionObserver' in window && !reduced ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function observe(scope) { $$('.rv:not(.in)', scope).forEach(function (el) { if (!io || el.getBoundingClientRect().top < innerHeight) el.classList.add('in'); else io.observe(el); }); }

  /* ---------- Golden dust (hero and password page) ---------- */
  var dustOn = false, raf = 0;
  function stopDust() { dustOn = false; cancelAnimationFrame(raf); }
  function startDust() {
    var cv = $('#dust'); if (!cv || reduced || dustOn) return;
    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, pts = [];
    function size() { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener('resize', size);
    var n = Math.round(Math.min(90, W / 14));
    for (var i = 0; i < n; i++) pts.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.8 + .4, s: Math.random() * .35 + .08, ph: Math.random() * 6.28, a: Math.random() * .5 + .2 });
    dustOn = true;
    (function tick(t) {
      if (!dustOn) return;
      ctx.clearRect(0, 0, W, H);
      for (var j = 0; j < pts.length; j++) {
        var p = pts[j];
        p.y -= p.s; p.x += Math.sin(t / 2400 + p.ph) * .25;
        if (p.y < -6) { p.y = H + 6; p.x = Math.random() * W; }
        var tw = .55 + .45 * Math.sin(t / 900 + p.ph * 3);
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = 'rgba(240,210,160,' + (p.a * tw).toFixed(3) + ')';
        ctx.shadowColor = 'rgba(232,196,138,.8)'; ctx.shadowBlur = p.r * 4;
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    })(0);
  }

  /* ---------- Layers: menu, search, bag ---------- */
  var lastFocus = null;
  function showLayer(html, focusSel) {
    var L = $('#layers'); if (!L) return;
    if (!L.innerHTML) lastFocus = document.activeElement;
    if (typeof html === 'string') L.innerHTML = html; else { L.innerHTML = ''; L.appendChild(html); }
    document.body.style.overflow = 'hidden';
    var f = $(focusSel || '#layers [data-close].ibtn'); if (f) f.focus();
  }
  function closeLayer() {
    var L = $('#layers'); if (!L || !L.innerHTML) return;
    L.innerHTML = ''; document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus(); lastFocus = null;
  }
  function fromTemplate(id) { var t = document.getElementById(id); return t ? t.content.cloneNode(true) : null; }

  /* Search with live suggestions */
  var sTimer = 0;
  function openSearch(q) {
    var node = fromTemplate('tplSearch'); if (!node) return;
    showLayer(node, '#sInput');
    var inp = $('#sInput'); inp.value = q || ''; if (q) suggest(q);
  }
  function suggest(q) {
    var box = $('#sRes'); if (!box) return;
    q = q.trim(); if (!q) { box.innerHTML = ''; return; }
    fetch((R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!list.length) { box.innerHTML = '<p class="lead" style="margin-top:24px">No perfumes found for “' + esc(q) + '”. Try a name like Sauvage or a brand like Tom Ford.</p>'; return; }
        box.innerHTML = '<div class="sres">' + list.map(function (p, i) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var pr = parseFloat(p.price) > 0 ? '<span class="pr">' + esc(money(Math.round(parseFloat(p.price) * 100))) + '</span>' : '';
          return '<a href="' + esc(p.url) + '" style="animation-delay:' + i * 30 + 'ms">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '') + '<span><b>' + esc(p.title) + '</b></span>' + pr + '</a>';
        }).join('') + '</div>';
      }).catch(function () { box.innerHTML = ''; });
  }

  /* Bag drawer, driven by Shopify's /cart.js */
  var cartState = null;
  function setCount(n) {
    var b = $('#cartCount'); if (!b) return;
    b.textContent = n; b.hidden = n === 0;
    var btn = $('#cartBtn'); if (btn) btn.setAttribute('aria-label', 'Open bag, ' + n + ' item' + (n === 1 ? '' : 's'));
    b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
  }
  function getCart() { return fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function orderText(cart) { return 'Hi NAWA, I\'d like to order:\n' + cart.items.map(function (i) { return '- ' + i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : '') + ' x' + i.quantity; }).join('\n'); }
  function cartBody(cart) {
    var n = cart.item_count;
    var rows = !n
      ? '<div class="empty"><p class="title" style="font-size:28px">Your bag is empty</p><p style="margin:0;color:var(--muted)">Find a scent you\'ll love wearing every day.</p><a href="' + esc(R.all || '/collections/all') + '" class="btn" style="margin-top:8px">Shop perfumes</a></div>'
      : cart.items.map(function (it, i) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        return '<div class="ci">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '<div class="t"><b>' + esc(it.product_title) + '</b>' + (it.variant_title ? '<small>' + esc(it.variant_title) + ' · Extrait de parfum</small>' : '') +
          '<div class="mini" role="group" aria-label="Quantity of ' + esc(it.product_title) + '"><button data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="One less">−</button><span>' + it.quantity + '</span><button data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button></div></div>' +
          '<div class="pr">' + esc(money(it.final_line_price)) + '<button class="u-btn" data-line="' + (i + 1) + '" data-q="0">Remove</button></div></div>';
      }).join('');
    return '<div class="p-head"><h2>Your bag' + (n ? ' (' + n + ')' : '') + '</h2><button class="ibtn" data-close aria-label="Close bag"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="c-items">' + rows + '</div>' +
      (n ? '<div class="c-foot"><div class="sub"><span>Subtotal</span><b style="font-weight:500">' + esc(money(cart.total_price)) + '</b></div><p>Delivery all over Lebanon. Pay cash when your order arrives.</p>' +
        '<a class="btn block" href="/checkout">Checkout</a>' +
        (C.whatsapp ? '<a class="btn wa block" href="' + esc(waUrl(orderText(cart))) + '" target="_blank" rel="noopener">Order on WhatsApp</a>' : '') +
        '<a class="u-btn" href="' + esc(R.cart || '/cart') + '" style="align-self:center">View bag</a></div>' : '');
  }
  function renderCart(cart) {
    cartState = cart; setCount(cart.item_count);
    var p = $('#cartPanel');
    if (p) p.innerHTML = cartBody(cart);
    else showLayer('<div class="layer"><button class="scrim" data-close aria-label="Close bag"></button><div class="panel r" id="cartPanel" role="dialog" aria-modal="true" aria-label="Your bag">' + cartBody(cart) + '</div></div>');
  }
  function openCart() { getCart().then(renderCart).catch(function () { location.href = R.cart || '/cart'; }); }
  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('busy');
    return fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return getCart(); })
      .then(renderCart)
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add to your bag. Please try again.'); })
      .then(function () { if (btn) btn.classList.remove('busy'); });
  }
  function changeLine(line, q) {
    fetch((R.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +line, quantity: Math.max(0, +q) }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Could not update your bag.'); });
  }

  /* ---------- Product page ---------- */
  var qty = 1;
  function initProduct() {
    var form = $('#productForm'); if (!form) return;
    var vid = $('#variantId'), price = $('#pprice'), addBtn = $('#addBtn'), addLbl = $('#addLbl'), mAdd = $('#mbarAdd'), mSub = $('#mbarSub');
    function selectBtn(b) {
      var seg = b.closest('.seg');
      $$('[data-variant]', seg).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      seg.style.setProperty('--i', b.dataset.index);
      vid.value = b.dataset.variant;
      if (price) price.textContent = b.dataset.price;
      var zero = b.dataset.zero === '1', avail = b.dataset.available === '1';
      var ok = !zero && avail;
      if (addBtn) addBtn.disabled = !ok; if (mAdd) mAdd.disabled = !ok;
      if (addLbl) addLbl.textContent = zero ? 'Coming soon' : avail ? 'Add to bag' : 'Sold out';
      if (mSub) mSub.textContent = b.dataset.title.replace('ml', ' ml') + ' · ' + b.dataset.price;
      try { var u = new URL(location.href); u.searchParams.set('variant', b.dataset.variant); history.replaceState(null, '', u); } catch (e) {}
    }
    $$('[data-variant]').forEach(function (b) { b.addEventListener('click', function () { selectBtn(b); }); });
    form.addEventListener('submit', function (e) { e.preventDefault(); if (addBtn && addBtn.disabled) return; addToCart(vid.value, qty, addBtn); });
    if (mAdd) mAdd.addEventListener('click', function () { if (!mAdd.disabled) addToCart(vid.value, qty, mAdd); });
    var wa = $('#waOrder');
    if (wa) wa.addEventListener('click', function () {
      var sel = $('[data-variant][aria-pressed="true"]');
      wa.href = waUrl('Hi NAWA, I\'d like to order ' + wa.dataset.product + (sel ? ' (' + sel.dataset.title + ')' : '') + ' x' + qty);
    });
    var z = $('#zoom');
    if (z) z.addEventListener('pointermove', function (e) { var img = z.querySelector('img'); if (!img) return; var r = z.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });
    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = $('#zoom img'); if (!img) return;
        img.removeAttribute('srcset'); img.src = t.dataset.thumb;
        $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t); });
      });
    });
    var row = $('#buyrow'), bar = $('#mbar');
    if (row && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; bar.classList.toggle('show', show); document.body.classList.toggle('has-mbar', show); }).observe(row);
    }
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t) return;
    var d = t.dataset;
    if (t.id === 'menuBtn') { var m = fromTemplate('tplMenu'); if (m) showLayer(m); return; }
    if (t.id === 'searchBtn') return openSearch('');
    if (t.id === 'cartBtn' && $('#layers')) { e.preventDefault(); return openCart(); }
    if ('close' in d) return closeLayer();
    if ('closeAfter' in d) { closeLayer(); return; }
    if (t.classList.contains('js-add')) return addToCart(d.id, 1, t);
    if (d.line) return changeLine(d.line, d.q);
    if (d.jump) { var j = document.getElementById(d.jump); if (j) { e.preventDefault(); j.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' }); } return; }
    if (d.rail) { var r = document.getElementById(d.target); if (r) r.scrollBy({ left: +d.rail * r.clientWidth * .9, behavior: 'smooth' }); return; }
    if (d.qty) { qty = Math.max(1, Math.min(10, qty + +d.qty)); var n = $('#qtyN'), qi = $('#qtyIn'); if (n) n.textContent = qty; if (qi) qi.value = qty; return; }
    if ('acc' in d) { var open = t.getAttribute('aria-expanded') !== 'true'; t.setAttribute('aria-expanded', open); var pn = document.getElementById(t.getAttribute('aria-controls')); if (pn) pn.classList.toggle('open', open); return; }
    if (d.chip) { var si = $('#sInput'); if (si) { si.value = d.chip; suggest(d.chip); } return; }
  });
  document.addEventListener('input', function (e) { if (e.target.id === 'sInput') { clearTimeout(sTimer); var v = e.target.value; sTimer = setTimeout(function () { suggest(v); }, 160); } });
  document.addEventListener('change', function (e) { if (e.target.id === 'sortSel') { var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString(); } });
  document.addEventListener('submit', function (e) { if (e.target.id === 'heroSearch') { e.preventDefault(); openSearch($('#heroQ').value); } });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') return closeLayer();
    if (e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) && $('#tplSearch')) { e.preventDefault(); openSearch(''); }
  });

  /* ---------- Header on scroll ---------- */
  var hdr = $('#hdr'), pbar = $('#pbar'), ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY, max = document.documentElement.scrollHeight - innerHeight;
      if (hdr) hdr.classList.toggle('scrolled', y > 30);
      if (pbar) pbar.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      var hero = $('#hero'); if (hero) { if (y > hero.offsetHeight && dustOn) stopDust(); else if (y <= hero.offsetHeight && !dustOn) startDust(); }
      ticking = false;
    });
  }, { passive: true });

  /* ---------- Boot ---------- */
  function boot() {
    var intro = $('#intro'), seen = false;
    if (intro) {
      try { seen = sessionStorage.getItem('nawaIntro') === '1'; sessionStorage.setItem('nawaIntro', '1'); } catch (e) {}
      if (seen || reduced) intro.remove();
      else { intro.hidden = false; intro.addEventListener('click', function () { intro.remove(); }); setTimeout(function () { if (intro.parentNode) intro.remove(); }, 2600); }
    }
    observe();
    setTimeout(function () { $$('.hero, .c-hero').forEach(function (h) { h.classList.add('go'); }); }, document.contains(intro) ? 1900 : 30);
    startDust();
    var hero = $('#hero'), img = $('#heroImg');
    if (hero && img && !reduced && matchMedia('(pointer:fine)').matches) {
      hero.addEventListener('pointermove', function (e) { var r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; img.style.transform = 'translate(' + (x * -22) + 'px,' + (y * -16) + 'px) rotate(' + (x * -2) + 'deg)'; });
      hero.addEventListener('pointerleave', function () { img.style.transform = ''; });
    }
    initProduct();
    // Theme editor: re-run reveal when sections are re-rendered
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); $$('.rv', e.target).forEach(function (el) { el.classList.add('in'); }); $$('.hero, .c-hero', e.target).forEach(function (h) { h.classList.add('go'); }); stopDust(); startDust(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
